import { usePersistedSetting } from "@@common";
import React, { createContext, useContext, useState } from "react";

const MASK_PII_SETTING_KEY = "runtime.maskPii";

type MaskingContextValue = {
  maskPii: boolean;
  setMaskPii: (value: boolean | ((prev: boolean) => boolean)) => void;
};

const MaskingContext = createContext<MaskingContextValue | undefined>(undefined);

function PersistentMaskingProvider({ children }: React.PropsWithChildren) {
  const [maskPii, setMaskPii] = usePersistedSetting<boolean>(MASK_PII_SETTING_KEY, false, true);

  return <MaskingContext.Provider value={{ maskPii, setMaskPii }}>{children}</MaskingContext.Provider>;
}

function MemoryMaskingProvider({ children }: React.PropsWithChildren) {
  const [maskPii, setMaskPii] = useState(false);
  return <MaskingContext.Provider value={{ maskPii, setMaskPii }}>{children}</MaskingContext.Provider>;
}

export function MaskingProvider({ children, persistent = true }: React.PropsWithChildren<{ persistent?: boolean }>) {
  return persistent ? <PersistentMaskingProvider>{children}</PersistentMaskingProvider> : <MemoryMaskingProvider>{children}</MemoryMaskingProvider>;
}

export function useMaskingContext(): MaskingContextValue {
  const context = useContext(MaskingContext);
  if (!context) {
    throw new Error("useMaskingContext must be used within a MaskingProvider.");
  }

  return context;
}
